/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Pick_NewInputs */

const en_dr_pick_new = /** @type {(inputs: Dr_Pick_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New workspace`)
};

const id_dr_pick_new = /** @type {(inputs: Dr_Pick_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace baru`)
};

/**
* | output |
* | --- |
* | "New workspace" |
*
* @param {Dr_Pick_NewInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_pick_new = /** @type {((inputs?: Dr_Pick_NewInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Pick_NewInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_pick_new(inputs)
	return en_dr_pick_new(inputs)
});